import React from "react";
import AlertCard from "./panel/alertCard";
import CoverBunner from "./panel/coverBunner";
import BuyReseller from "./reseller/buyReseller";
import DescriptionReseller from "./reseller/descriptionReseller";
import CloudLandlineReseller from "./vop/cloudLandlineReseller";
import DescriptionReseller2 from "./vop/descriptionReseller2";
import { toNumeric } from "../../utility/stringExtensions";
const Reseller = () => {
  return (
    <div>
      <DescriptionReseller />
      <BuyReseller />
      <CoverBunner
        description={
          <ol type="1" className="text-bold text-justify">
            <li>10 ریال مصوب مجلس به تعرفه ارسال پیامک اضافه خواهد شد.</li>
            <br />
            <li>
              نمایندگان میتوانند خطوط خدماتی را در اختیار کاربران خود قرار دهند
            </li>
            <br />
            <li>دریافت پیامک با خطوط اختصاصی فعال و رایگان میباشد</li>
            <br />
            <li>در همه اپراتور ها هزینه ارسال نشده ها بازگشت داده میشود</li>
            <br />
            <li>در نمایندگی پلن1 امکان ارائه نمایندگی وجود ندارد.</li>
            <br />
            <li>
              در نمایندگی پلن2 هزینه ایجاد نمایندگی: پنج نمایندگی اول هرکدام
              50هزار تومان و مابقی رایگان است.
            </li>
            <br />
            <li>در نمایندگی پلن 3 ایجاد نمایندگی رایگان و نامحدود است</li>
            <br />
            <li>پلن های پایین تر در هر زمان قابل ارتقا به پلن بالاتر هستند</li>
          </ol>
        }
      />
      <CloudLandlineReseller />
      <DescriptionReseller2 />
      <AlertCard
        color="#F4C2C2"
        header="زیرمجموعه شما ارسالهای بسیار بالایی دارند؟ پکیج های سازمانی برای شما باصرفه تر خواهند بود"
        description={
          <div>
            پنل نمایندگی سازمانی1: در هر بار خرید پنج میلیون تومان شارژ،{" "}
            <toNumeric
              value={496200}
              displayType={"text"}
              thousandSeparator={true}
            />{" "}
            عدد اعتبار پیامک دریافت کنید (3% ارزانتر)
            <br />
            پنل نمایندگی سازمانی2: در هر بار خرید ده میلیون تومان شارژ،
            {toNumeric(1011000)}
            عدد اعتبار پیامک دریافت کنید (5% ارزانتر)
            <br />
            جهت اطلاع از شرایط دقیق پنل های نمایندگی سازمانی تماس بگیرید
            02165626933
          </div>
        }
      />
      <AlertCard
        color="#A2A2D0"
        header="قبل از پرداخت هزینه پنل، سامانه را کامل مشاهده و بررسی کنید"
        description={
          <div>
            بلافاصله بعد از پر کردن فرم ثبت نام، پنل شما خودکار ایجاد میشود و با
            شناسه کاربری و رمز عبوری که انتخاب کرده اید میتوانید وارد پنل خود
            شده و بعد از مشاهده پنل، هزینه را پرداخت کنید.
            <a
              href="http://sms.sayyehban.ir/register.jspd"
              className="btn btn-info"
              style={{ width: "100%" }}
            >
              ثبت نام آنلاین نمایندگی سایه بان
            </a>
          </div>
        }
      />
      <AlertCard
        color="#ACE5EE"
        header="تمام پنل ها دائمی و بدون نیاز به هزینه تمدید واگذار میشوند"
        description={
          <div>
            در سایه بان برخلاف بسیاری از ارائه دهندگان خدمات پیامک, هزینه پنل
            فقط یکبار اخذ میشود و سالهای بعدی هیچ هزینه اضافه دیگری بابت تمدید
            پنل از کاربران دریافت نمیشود
          </div>
        }
      />
      <AlertCard
        color="#E3DAC9"
        header="نمیتوانید تصمیم بگیرید کدام پکیج برای شما مناسب است؟"
        description={<div>جهت مشاوره با بخش فروش تماس بگیرید: 02165626933</div>}
      />
    </div>
  );
};

export default Reseller;
